import { render, staticRenderFns } from "./BorderContainer.vue?vue&type=template&id=227d63c8&scoped=true&"
import script from "./BorderContainer.vue?vue&type=script&lang=ts&"
export * from "./BorderContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BorderContainer.vue?vue&type=style&index=0&id=227d63c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d63c8",
  null
  
)

export default component.exports